export default {"src":"/_next/static/media/close-icon.9c28ff6a.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};